import { IFetchBundlesSchema } from '@bitmap/contracts';
import { createContext } from '../../../../../../../libs/utils/src/lib/utils/createContext';
import { IGallery, IProductRange } from '@/src/interfaces/generated/contentful';

type IRangeContext = {
  range: IProductRange;
  gallery: IGallery | null;
  ranges: IProductRange[];
  bundles: IFetchBundlesSchema;
};

export const [RangeContext, useRangeContext] = createContext<IRangeContext>();
